import React, { useEffect, useState } from "react";
import { GoogleOAuthProvider } from "@react-oauth/google";

const API_BASE = process.env.REACT_APP_API_URL?.replace(/\/$/, "") || "http://localhost:8000/innofoot-dev";

export function GoogleOAuthWrapper({ children }: { children: React.ReactNode }) {
  const [clientId, setClientId] = useState<string | null>(null);

  useEffect(() => {
    fetch(`${API_BASE}/config/oauth`)
      .then((res) => res.json())
      .then((data) => {
        if (data.google_client_id) {
          setClientId(data.google_client_id);
        }
      })
      .catch((err) => console.error("Failed to load OAuth config", err));
  }, []);

  return (
    <GoogleOAuthProvider clientId={clientId || "waiting-for-backend-client-id"}>
      {children}
    </GoogleOAuthProvider>
  );
}
